import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/research-perf-evaluation/criteria-item');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'ResearchPerfEval-item',
  validationApi,
);

export function getResearchPerfEvalItemValidationHistoryOptions(
  ResearchPerfEvalItemId: Id,
): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(ResearchPerfEvalItemId);
}

export function getResearchPerfEvalItemValidationOptions(
  ResearchPerfEvalItemId: Id,
): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(ResearchPerfEvalItemId);
}

export function useValidateResearchPerfEvalItem(ResearchPerfEvalItemId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(ResearchPerfEvalItemId, queryClient));
}
